export const updateInterests = (interests) => {
	return {
		interests,
		type: 'UPDATE_INTERESTS'
	}
};